const AllowedTimeBeforeShift = 'AllowedTimeBeforeShift';
const ShiftMayOverlap = 'ShiftMayOverlap';
const EmployeNotOnProbation = 'EmployeNotOnProbation';
const ScheduleRules = 'ScheduleRules';
const SkillsAndCertifs = 'SkillsAndCertifs';
const JobTransferSetValidation = 'JobTransferSetValidation';
const DateAndDuration = 'DateAndDuration';
const RestBetweenShifts = 'RestBetweenShifts';
const EmployeeEligibility = 'EmployeeEligibility';
const MultipleShiftOnSameDay = 'MultipleShiftOnSameDay';
const MaxHoursInRollingPeriod = 'MaxHoursInRollingPeriod';
const PaycodeOverlap = 'PaycodeOverlap';
const EmployeeRestriction = 'EmployeeRestriction'
const IsOnlySwapOnSameWeek = 'IsOnlySwapOnSameWeek'
const SameDayPaycode = "SameDayPaycode"
const VtoOverlap = 'VtoOverlap'

export default Object.freeze({
    [AllowedTimeBeforeShift]: 1,
    [ShiftMayOverlap]: 2,
    [EmployeNotOnProbation]: 4,
    [ScheduleRules]: 5,
    [SkillsAndCertifs]: 6,
    [JobTransferSetValidation]: 8,
    [DateAndDuration]: 9,
    [RestBetweenShifts]: 10,
    [EmployeeEligibility]: 11,
    [MultipleShiftOnSameDay]: 12,
    [MaxHoursInRollingPeriod]: 13,
    [PaycodeOverlap]: 14,
    [EmployeeRestriction]: 15,
    [IsOnlySwapOnSameWeek]: 16,
    [SameDayPaycode]: 17,
    [VtoOverlap]: 1000,
});

export const ValidationTypeName = Object.freeze({
    1: [AllowedTimeBeforeShift],
    2: [ShiftMayOverlap],
    4: [EmployeNotOnProbation],
    5: [ScheduleRules],
    6: [SkillsAndCertifs],
    8: [JobTransferSetValidation],
    9: [DateAndDuration],
    10: [RestBetweenShifts],
    11: [EmployeeEligibility],
    12: [MultipleShiftOnSameDay],
    13: [MaxHoursInRollingPeriod],
    14: [PaycodeOverlap],
    15: [EmployeeRestriction],
    16: [IsOnlySwapOnSameWeek],
    17: [SameDayPaycode],
    1000: [VtoOverlap],
});
